import { create } from "zustand";
import { composeMiddleware } from "../middleware";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { StoreGet, StoreSet } from "@/types";
import { INotificationItem, INotificationStore } from "./type";
import { commonActions } from "../common";
import { NotificationAPI } from "./services";

export const initialNotificationState = () => ({
  notificationList: [] as INotificationItem[],
  platformNotice: "",
  platformNoticeModal: "",
  showPlatformNoticeModal: false,
  sysNoticeId: -1,
});

const actions = (
  set: StoreSet<INotificationStore>,
  get: StoreGet<INotificationStore>
) => ({
  ...commonActions(set, get),
  onCloseModal: () => {
    const { sysNoticeId } = get();
    set((s) => {
      s.showPlatformNoticeModal = false;
    });
    return NotificationAPI.recordUserSysNotice({ sysNoticeId });
  },
});

export const useNotificationStore = create<INotificationStore>()(
  composeMiddleware(
    [devtools, immer],
    (set: StoreSet<INotificationStore>, get: StoreGet<INotificationStore>) => ({
      ...initialNotificationState(),
      ...actions(set, get),
    })
  )
);
